<template>
  <form-item
    :prop="prop"
    :label="label"
    :description="description"
    :hint="hint"
    :rules="rules"
    :error="error"
  >
    <slot></slot>
    <template #label>
      <slot name="label"></slot>
    </template>
  </form-item>
</template>

<script>
import FormItem from '@/common/components/form/FormItem'

export default {
  name: 'RestFormItem',

  components: { FormItem },

  inject: ['restForm'],

  props: {
    prop: {
      type: String,
      required: false
    },

    label: {
      type: String,
      required: false
    },

    description: {
      type: String,
      required: false
    },

    hint: {
      type: String,
      required: false
    },

    rules: {
      type: Object,
      required: false
    }
  },

  computed: {
    error() {
      let error = this.restForm.error(this.prop)
      return error ? error.message : null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestFormItem.vue